<template>
    <div>
        <Modal v-model="modalShow" title="充值" class-name="vertical-center-modal my-modal"
            @on-cancel="cancel" :mask-closable="false" :loading="submitLoading"
            width="660" :footer-hide="true">
            <div class="pay-dialog-body">
                <div class="pay-user-info">账户余额 <b>{{ user.amount || 0 }}</b> 焕新币</div>
                <div class="money-list">
                    <div v-for="(item, index) in moneyList" :key="index" class="money-item" @click="selectMoney(item)">
                        <img v-if="item.selected" src="@/assets/img/live/selected.png" class="selected-logo">
                        <p>
                            <img src="@/assets/img/live/hxb.png" class="hxb-logo">
                        </p>
                        <p><b>{{ item.label }}</b></p>
                        <p class="bottom">{{ item.label }}</p>
                    </div>
                    <div class="money-item" @click="selectMoney(null)">
                        <img v-if="enterMoney != ''" src="@/assets/img/live/selected.png" class="selected-logo">
                        <p>
                            <img src="@/assets/img/live/hxb.png" class="hxb-logo">
                        </p>
                        <p style="margin:0 0 2px 0!important;">
                            <Input v-model="enterMoney" placeholder="输入金额" maxlength="8" style="font-size: 18px; font-weight:bold;"
                                @on-change="changeEnterMoney"/>
                        </p>
                        <p class="bottom" style="border: none;">{{enterMoney == '' ? '1' : enterMoney}}元</p>
                    </div>
                </div>
                <div class="pay-user-info" style="margin-top:20px">支付方式</div>
                <div class="paytype-list">
                    <div v-for="(item, index) in payTypeList" :key="index"
                        class="paytype-item" @click="selectPaytype(item)">
                        <img :src="item.img" :alt="item.name" class="paytype-logo" />
                        <span>{{ item.name }}</span>
                        <img v-if="item.selected" src="@/assets/img/live/selected.png" class="selected-logo">
                    </div>
                </div>

                <div class="pay-qrbox">
                    <div style="align-items: center; text-align: center;">
                        <img :src="txtPayType.img" :alt="txtPayType.name" class="paytype-logo"
                            style="display: inline;margin-top:0px;"/>
                        <span>
                            请使用{{ txtPayType.scanName }}，支付<span class="money">￥{{ txtPayMoney }}</span>元
                        </span>
                    </div>
                    <div class="pay-button" v-if="payButtonShow">
                        <Button type="primary" @click="payNow" :loading="submitLoading">立即支付</Button>
                    </div>
                    <div v-show="!payButtonShow">
                        <div class="qrcode" ref="qrCodeUrl"></div>
                    </div>
                    <p style="margin:10px 0 0 0;">
                        <CheckboxGroup v-model="checkboxVal">
                            <Checkbox label="1">&nbsp;&nbsp;同意充值服务协议</Checkbox>
                        </CheckboxGroup>
                    </p>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>

import {
    //充值 获取充值二维码 接口
    getPayQrcodeApi,
    //查询 充值 是否成功 接口
    queryPayResultApi,
} from '@/api/apis/liveUser.js';
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
export default {
    name: "ChongZhiModal",
    data() {
        return {
            modalShow: false,
            submitLoading: false,
            moneyList: [ //充值金额列表
                {label: '10', selected: true},
                {label: '50', selected: false},
                {label: '300', selected: false},
                {label: '1000', selected: false},
            ],
            payTypeList: [
                {name: '支付宝支付', scanName:'支付宝扫码', type: 'alipay', selected: true, img: require('@/assets/img/live/zfb.png')},
                {name: '微信支付', scanName:'微信扫码', type: 'wechatpay', selected: false, img: require('@/assets/img/live/wx.png')},
            ],
            enterMoney: '', //输入的金额
            formData: {
                uid: '', //用户id
                money: '10', //充值金额
                payType: 'alipay', //充值使用的支付方式
            },
            checkboxVal: ['1'], //勾选框的值
            payButtonShow: true, //是否显示立即支付按钮
            //查询支付结果
            timerQuery: null, //轮询
            qrData: {
                img: '', //二维码内容
                orderNo: '', //订单号
                scanImg: require('@/assets/img/live/scan_ok.png')
            },
        }
    },
    computed: {
        ...mapState(['isLogin', 'uuid', 'user']),
        txtPayMoney() {
            return this.enterMoney == '' ? this.formData.money : this.enterMoney
        },
        txtPayType() {
            return this.payTypeList.find(item => item.selected)
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.submitLoading = false
            this.payNow() //立即支付点击 事件
        })
    },
    methods: {
        //金额选择
        selectMoney(item){
            let that = this
            that.moneyList.forEach(item => { item.selected = false })
            if(!item){ //输入金额
                if(that.enterMoney != '') return
                that.enterMoney = '1' //输入的金额
                that.formData.money = 0
                that.payButtonShow = true //是否显示立即支付按钮
            }else{ //选择金额
                that.enterMoney = '' //输入的金额
                item.selected = true
                that.formData.money = item.label
                this.submitLoading = false
                that.payNow() //立即支付点击 事件
            }
        },
        //输入金额变化
        changeEnterMoney(e){
            let oldVal = this.enterMoney
            oldVal = oldVal.replace(/[^\d]/g, '')
            if(oldVal == '' || isNaN(Number(oldVal)) || Number(oldVal) <= 0) oldVal = 1
            this.enterMoney = oldVal
            this.payButtonShow = true //是否显示立即支付按钮
        },
        //选择支付方式
        selectPaytype(item){
            this.payTypeList.forEach(item => { item.selected = false })
            item.selected = true
            this.formData.payType = item.type //充值使用的支付方式
            this.submitLoading = false
            this.payNow() //立即支付点击 事件
        },
        //立即支付点击 事件
        payNow(){
            let that = this
            if(that.checkboxVal.length <= 0){
                that.qrData.img = '' //二维码内容
                that.qrData.orderNo = '' //订单号
                return this.$Message.warning('请勾选同意充值服务协议')
            }
            let postData = {
                payChannel: that.formData.payType == 'alipay' ? 'alipayPc' : 'native', //支付渠道： native=微信native支付， alipayPc=支付宝PC支付
                payType: that.formData.payType, //支付方式:wechatpay,alipay
                price: that.txtPayMoney, //订单金额
            }
            console.log('充值提交数据', postData)
            if(that.submitLoading) return
            that.submitLoading = true
            that.cancel() // 清除定时器
            getPayQrcodeApi(postData).then(res => {
                that.qrData.img = res.data.codeUrl //二维码内容
                that.qrData.orderNo = res.data.orderNo //订单号
                that.creatQrCode(that.qrData) //创建支付二维码
            }).finally(() => {
                that.submitLoading = false
            })
        },
        //创建支付二维码
        creatQrCode(qrData) {
            this.payButtonShow = false //是否显示立即支付按钮
            this.$nextTick(() => {
                this.$refs.qrCodeUrl.innerHTML = ''
                new QRCode(this.$refs.qrCodeUrl, {
                    text: qrData.img, //'https://blog.csdn.net/weixin_42601136', // 转换为二维码的内容
                    width: 160, height: 160,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                });
                this.submitLoading = false
                //扫码支付结果 轮询
                this.delayRequest()
            })
        },
        //显示支付成功
        async showPaySuccess(){
            let that = this
            // 清除定时器
            that.cancel()
            that.modalShow = false
            this.$Modal.success({
                title: '充值成功',
                content: '您的充值已到账，快去体验焕新生活吧！',
                onOk: () => { }
            });
        },
        //显示支付失败
        async showPayFail(){
            let that = this
            // 清除定时器
            that.cancel() 
            that.modalShow = false
            this.$Modal.error({
                title: '充值提示',
                content: '充值是否遇到问题？请立即与客服联系。',
                onOk: () => { }
            });
        },
        cancel() {
            // 清除定时器
            this.timerQuery && clearTimeout(this.timerQuery)
        },
        //扫码支付结果 轮询
        delayRequest() {
            clearTimeout(this.timerQuery) // 清除定时器
            // 5s后请求
            this.timerQuery = setTimeout(() => {
                this.requestPayResult()
            }, 1000)
        },
        //扫码支付结果 轮询
        requestPayResult() {
            let that = this
            queryPayResultApi(that.qrData.orderNo).then(async (res) => {
                //状态 支付状态(0=失败，1=成功,2=待支付)
                let resStatus = Number(res.data)
                if(resStatus == 1){ // 支付成功
                    //查询用户 焕新币余额
                    await that.$store.commit('queryUserAmount')
                    //显示支付成功
                    that.showPaySuccess()
                }
                if(resStatus == 0){ // 支付失败
                    //查询用户 焕新币余额
                    await that.$store.commit('queryUserAmount')
                    //显示支付失败
                    that.showPayFail()
                }
                if(resStatus == 2){ // 待支付
                    that.delayRequest()
                }
                if(resStatus == 3){ // 已关闭
                    // 清除定时器
                    that.cancel() 
                    that.$Message.warning('订单已关闭，请重新发起支付操作。')
                    window.location.reload() //刷新页面
                }
            }).catch(e => {
                this.delayRequest()
            })
        }
    },
    beforeDestroy() {
        // 清除定时器
        this.timerQuery && clearTimeout(this.timerQuery)
    },
};
</script>

<style lang="scss">
.my-modal .ivu-modal-header {
    border-bottom: 0px solid #e8eaec;
    padding: 14px 16px 0 16px;
}
</style>
<style lang="scss" scoped>
.paytype-logo {
    width: 22px;
    height: 22px;
    display: block;
    margin-right: 10px;
}

.pay-dialog-body {
    .pay-user-info {
        font-size: 15px;
    }

    .money-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        flex-wrap: wrap;
        margin-top: 10px;
        padding-left: 8px;
        .money-item {
            border: 1px solid #ff9600;
            text-align: center;
            width: 110px;
            border-radius: 4px;
            margin: 0 15px 15px 0;
            padding: 10px 15px 0px 15px;
            cursor: pointer;
            position: relative;
            .selected-logo{
                position: absolute; top: 0; right: 0;
                border-radius: 0 4px 0 0;
            }
            .hxb-logo {
                width: 30px;
                height: 30px;
                margin: 0 auto;
                display: block;
            }

            p {
                width: 100%;
                font-size: 12px;
                margin: 0 0 8px !important;
                b {
                    font-size: 18px;
                }
            }
            .bottom {
                border-top: 1px solid #e4e4e4;
                padding-top: 5px; font-size:14px;
            }
        }
        .money-item:last-child{
            margin-right: 0;
        }
    }

    .paytype-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        flex-wrap: wrap;
        margin-top: 10px;

        .paytype-item {
            border: 1px solid #ff9600;
            border-radius: 4px;
            margin: 0 15px 15px 0;
            padding: 5px 15px;
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            .selected-logo{
                position: absolute; top: 0; right: 0;
                border-radius: 0 4px 0 0;
            }
        }
    }

    .pay-qrbox {
        text-align: center;
        max-width: 300px; margin: 0 auto;
        .pay-qr-title {
            display: flex; margin:10px 0;
        }
        .money {
            color: #ff9600;
            font-size: 18px;
            font-weight: bold;
        }
        .qrcode {
            width: 160px;
            height: 160px;
            margin: 20px auto;
        }
        .pay-button{
            margin: 20px auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ChongZhiModal.vue